export enum YesNoIDK {
  YES = 'YES',
  NO = 'NO',
  IDK = 'IDK',
}
